<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{ aLang.c_list }} bác sĩ
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse
            v-bind:visible="mData.tableRules.showFormSearch"
            id="myFormSearch"
          >
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Họ đệm" prop="last_name">
                      <el-input
                        v-model="mData.tableRules.dataSearch.value.last_name"
                        placeholder="Nhập họ đệm để tìm kiếm"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item label="Tên bác sĩ" prop="first_name">
                      <el-input
                        v-model="mData.tableRules.dataSearch.value.first_name"
                        placeholder="Nhập tên bác sĩ để tìm kiếm"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item label="Bệnh viện" prop="hospital_code">
                      <el-select
                        v-model="
                          mData.tableRules.dataSearch.value.hospital_code
                        "
                        placeholder="Nhập tên bệnh viện"
                        no-data-text="Chưa có dữ liệu"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listBenhVien"
                          :key="item.ID"
                          :label="item.HOSPITAL_NAME"
                          :value="item.HOSPITAL_CODE"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item
                      label="Chứng chỉ hành nghề"
                      prop="license_code"
                    >
                      <el-input
                        v-model="mData.tableRules.dataSearch.value.license_code"
                        placeholder="Nhập chứng chỉ hành nghề để tìm kiếm"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                    >{{ aLang.c_search }}</el-button
                  >
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="12">
            <div class="text-right mb-2">
              <el-button @click="fn_tableShowFormSearch()" type="info" plain>{{
                aLang.c_showHideSearch
              }}</el-button>
              <el-button @click="fn_handle('create')" type="info" plain>{{
                aLang.c_create
              }}</el-button>
              <el-button @click="fn_importFile()" type="info" plain>{{
                "Nhập khẩu"
              }}</el-button>
            </div>
          </b-col>
        </b-row>
        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{
            prop: mData.tableRules.defaultSort[0],
            order: mData.tableRules.defaultSort[1],
          }"
        >
          <el-table-column
            type="index"
            label="STT"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="last_name"
            label="Họ đệm"
            sortable
          ></el-table-column>
          <el-table-column
            prop="first_name"
            label="Tên bác sĩ"
            sortable
          ></el-table-column>
          <el-table-column prop="hospital_name" label="Bệnh viện">
          </el-table-column>
          <el-table-column
            prop="license_code"
            label="Chứng chỉ hành nghề"
            sortable
          ></el-table-column>
          <el-table-column
            prop="created_time"
            label="Thời gian tạo"
            :formatter="fn_formatterDatetime"
            width="150"
            align="center"
            :sortable="mData.tableRules.allowSorting"
          ></el-table-column>
          <el-table-column width="200" align="center" label="Thao tác">
            <template slot-scope="scope">
              <el-button
                icon="el-icon-view"
                @click="fn_handle('detail', scope, scope.row)"
              ></el-button>
              <el-button
                icon="el-icon-edit"
                @click="fn_handle('update', scope, scope.row)"
              ></el-button>
              <el-button
                icon="el-icon-delete"
                @click="fn_handle('delete', scope, scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">
              {{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
            </div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
    <el-dialog
      :title="mData.dataDefault.titleDialog"
      :visible.sync="mData.dataDefault.dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escapse="false"
      :show-close="false"
    >
      <div style="padding: 20px">
        <el-form
          ref="FormData"
          :model="mData.dataForm"
          :rules="mData.validForm"
        >
          <el-form-item label="Họ đệm" prop="last_name">
            <el-input
              v-model="mData.dataForm.last_name"
              :disabled="mData.dataDefault.action == 'detail'"
            ></el-input>
          </el-form-item>
          <el-form-item label="Tên bác sĩ" prop="first_name">
            <el-input
              v-model="mData.dataForm.first_name"
              :disabled="mData.dataDefault.action == 'detail'"
            ></el-input>
          </el-form-item>
          <el-form-item label="Bệnh viện" prop="hospital_code">
            <el-select
              v-model="mData.dataForm.hospital_code"
              placeholder="Nhập tên bệnh viện hoặc mã bệnh viện để tìm kiếm"
              no-data-text="Chưa có dữ liệu"
              clearable
              filterable
              remote
              :disabled="mData.dataDefault.action == 'detail'"
              @change="fn_changeBenhVien($event)"
            >
              <el-option
                v-for="item in mData.dataDefault.listBenhVien"
                :key="item.ID"
                :label="item.HOSPITAL_NAME + ' - ' + item.HOSPITAL_CODE"
                :value="item.HOSPITAL_CODE"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Chứng chỉ hành nghề" prop="license_code">
            <el-input
              v-model.trim="mData.dataForm.license_code"
              :disabled="mData.dataDefault.action == 'detail'"
            ></el-input>
          </el-form-item>
        </el-form>
        <div
          slot="footer"
          class="dialog-footer"
          style="display: flex; justify-content: center"
        >
          <el-button
            v-if="mData.dataDefault.action == 'update'"
            type="primary"
            @click="fn_submitForm(mData.dataDefault.action)"
            v-ladda
            >Cập nhật</el-button
          >
          <el-button
            v-if="mData.dataDefault.action == 'create'"
            type="primary"
            @click="fn_submitForm(mData.dataDefault.action)"
            >Thêm mới</el-button
          >
          <el-button @click="fn_closeDialog()">Đóng</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import BacSiVienModel from "./BacSiVienModel";
import BacSiVienApi from "../../../moduleApi/BacSiVienApi";
import AuthService from "../../../service/AuthService";
import * as moment from "moment";
import { Buffer } from "buffer";
import mushroom from "../../../service/mushroom.api.def";
import { METHODS } from "http";
import DkkApi from "../../../moduleApi/DkkApi";

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "BacSi", //requied
        tableRules: MethodService.copyObject(BacSiVienModel.tableRules),
        dataDefault: {
          textFindBenhVien: "",
          listBenhVien: [],
          titleDialog: "",
          action: null,
          dialogVisible: false,
        },
        dataForm: MethodService.copyObject(BacSiVienModel.dataForm),
        validForm: MethodService.copyObject(BacSiVienModel.validForm),
      },
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort ? this.mData.tableRules.sort : encodeURI("-created_time,hospital_name");
      }

      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch,
          },
        }).catch(error => {});
      }

      let res = await BacSiVienApi.list(dataFilter);

      let data = [];
      res.result.forEach((item) => {
        let self = this;
        let cache = MethodService.copyObject(BacSiVienModel.dataForm);
        for (let key of Object.keys(item)) {
          cache[key] = item[key];
        }
        data.push(cache);
      });
      this.mData.tableRules.data = data;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    //xử lý dữ liệu đầu ra
    changeData(data) {},

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.mData.dataDefault.dialogVisible = true;
        this.mData.dataDefault.action = "create";
        this.mData.dataDefault.titleDialog = "Thêm mới bác sĩ";
      }
      if (type == "update") {
        this.mData.dataDefault.dialogVisible = true;
        this.mData.dataDefault.id = row.id;
        this.mData.dataDefault.action = "update";
        this.mData.dataDefault.titleDialog = "Cập nhật thông tin bác sĩ";
        this.fn_getDataById(row);
      }
      if (type == "detail") {
        this.mData.dataDefault.dialogVisible = true;
        this.mData.dataDefault.id = row.id;
        this.mData.dataDefault.action = "detail";
        this.mData.dataDefault.titleDialog = "Thông tin bác sĩ";
        this.fn_getDataById(row);
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      await BacSiVienApi.delete(id);
      this.fn_initTable();
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          if (this.mData.tableRules.dataSearch.value.name) {
            this.mData.tableRules.dataSearch.value.name = this.mData.tableRules.dataSearch.value.name.trim();
          }
          if (this.mData.tableRules.dataSearch.value.license_code) {
            this.mData.tableRules.dataSearch.value.license_code = this.mData.tableRules.dataSearch.value.license_code.trim();
          }
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query,
      });
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
        if (this.mData.tableRules.dataSearch.value.nhom_benh_ids) {
          this.mData.dataDefault.listNhomBenhSelected = this.mData.tableRules.dataSearch.value.nhom_benh_ids.split(
            ","
          );
        }
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },

    async fn_initData() {
      try {
        let body = {
          account: "tichhop",
          password: "tichhop",
        };
        let req = await fetch(`${mushroom.$using()}auth/login`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        });
        let res = await req.json();
        let response = await DkkApi.getHospital(null, res.result.token);
        this.mData.dataDefault.listBenhVien = response.data.Data;
      } catch (err) {
        toastr.warning("Lỗi tải dữ liệu");
      }
    },
    fn_submitForm(type) {
      this.mData.dataForm.name = this.mData.dataForm.name ? this.mData.dataForm.name.trim() : "";
      this.mData.dataForm.license_code = this.mData.dataForm.license_code ? this.mData.dataForm.license_code.trim() : "";
      this.$refs["FormData"].validate(async (valid) => {
        if (valid) {
          if (type == "create") {
            try {
              let bs = await mushroom.bac_sy.createAsync(this.mData.dataForm);
              console.log("bs", bs);
              this.fn_initTable();
              toastr.success("Thêm mới thành công!");
            } catch (er) {
              if (er.detail == "Violate unique key constraint") {
                toastr.error("Chứng chỉ hành nghề đã tồn tại!");
              } else {
                toastr.error("Có lỗi xảy ra!");
              }
            }
            this.fn_resetForm();
            MethodService.stopLadda();
          }
          if (type == "update") {
            try {
              await mushroom.bac_sy.partialUpdateAsync(this.mData.dataForm);
              this.fn_initTable();
              toastr.success("Cập nhật thành công!");
            } catch (er) {
              console.log(er.code);
              if (er.code == -1) {
                toastr.error("Chứng chỉ hành nghề đã tồn tại!");
              } else {
                toastr.error("Có lỗi xảy ra!");
              }
            }
            this.fn_resetForm();
            MethodService.stopLadda();
          }
          this.mData.dataDefault.dialogVisible = false;
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    async fn_getDataById(row) {
      this.mData.dataForm = MethodService.copyObject(row);
    },
    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(BacSiVienModel.dataForm);
      this.$refs["FormData"].resetFields();
    },
    fn_closeDialog() {
      this.fn_resetForm();
      this.mData.dataDefault.dialogVisible = false;
    },
    remoteMethod(query) {
      if (query.trim() == "") {
        this.mData.dataForm.hospital_code = null;
      } else {
        let cache = this.mData.dataDefault.listBenhVien.find(
          (item) => item.HOSPITAL_CODE == query.trim()
        );
        if (cache && cache.HOSPITAL_CODE) {
          this.mData.dataForm.hospital_code = cache.HOSPITAL_CODE;
        } else {
          this.mData.dataForm.hospital_code = null;
        }
      }
    },
    fn_importFile() {
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-import"
      });
    },
    fn_changeBenhVien(event) {
      if(!event)
      {
        this.mData.dataForm.hospital_name = "";
        return;
      }
      let cache = this.mData.dataDefault.listBenhVien.find(hospital => event == hospital.HOSPITAL_CODE);
      this.mData.dataForm.hospital_name = cache && cache.HOSPITAL_NAME ? cache.HOSPITAL_NAME : "";
    }
  },

  //run after render view
  created() {
    this.fn_hashUrl();
    this.fn_initData();
  },
  mounted() {
    this.fn_initTable();
  },
};
</script>
